export default __webpack_public_path__ + "static/media/sdg_ai_lab.c974fbd1.png";